import { Getter, GetterTree } from "vuex";
import { RootState } from "@/store/RootState";
import {
  ChannelChangeGetter,
  ChannelChangeState
} from "@/components/channelChange/types";

export const getters: GetterTree<ChannelChangeState, RootState> &
  Record<ChannelChangeGetter, Getter<ChannelChangeState, RootState>> = {
  [ChannelChangeGetter.GetChannelNumber](state) {
    return state.channelNumber;
  },
  [ChannelChangeGetter.GetChannelChange](state) {
    return state.showChannelChange;
  },
  [ChannelChangeGetter.GetSource](state) {
    return state.source;
  },
  [ChannelChangeGetter.GetOffset](state) {
    return state.offset;
  },
  [ChannelChangeGetter.GetChannelId](state) {
    return state.channelId;
  }
};
